import React from 'react'
import { Button } from '../ButtonElements';
import { useState } from 'react';
import {
    InfoContainer,
    InfoWrapper,
    InfoRow,
    Column1,
    TextWrapper,
    Heading,
    DescriptionWrapper,
    DescriptionText,
    CardIntro
}
    from './WhyUsElements'
import CardSection from './CardSection';
const WhyUs = (
    {
        lightBg,
        id,
        lightText,
        headline1,
        topLine1,
        description1,
        description2,
        description3,

    }
) => {

    const [showFullDescription, setShowFullDescription] = useState(false);

    const toggleDescription = () => {
        setShowFullDescription(!showFullDescription);
    };
    return (
        <>
            <InfoContainer lightBg={lightBg} id={id}>
                <InfoWrapper>
                    <InfoRow>
                        <Column1>
                            <TextWrapper >
                                <CardIntro>
                                    {/* {topLine1} */}
                                    <Heading lightText={lightText}>{headline1}</Heading>
                                </CardIntro>
                                <DescriptionWrapper>
                                    <DescriptionText>
                                        {description1}
                                    </DescriptionText>
                                    <DescriptionText>
                                        {description2}
                                    </DescriptionText>
                                    <DescriptionText>
                                        {description3}
                                    </DescriptionText>
                                </DescriptionWrapper>
                                <CardSection />
                            </TextWrapper>
                        </Column1>
                    </InfoRow>
                </InfoWrapper>
            </InfoContainer>
        </>
    )
}

export default WhyUs